module.exports = __webpack_public_path__ + "assets/img/order_10.9fb4a396.svg";